module.exports = __webpack_public_path__ + "img/nom.3b10094d.svg";